export default "__VITE_ASSET__BxKYEekU__"